import { Package, Truck, MapPin, Globe } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
const heroImage = "/hero-warehouse.webp";

const HeroSection = () => {
  const trustBadges = [
    { icon: Package, label: "Large Inventory in USA", to: "/about" },
    { icon: Truck, label: "Worldwide Shipping", to: "/shipping-policy" },
    { icon: MapPin, label: "Windermere, FL", to: "/about" },
    { icon: Globe, label: "Multi-Brand Availability", to: "/manufacturers" },
  ];

  const scrollToQuote = () => {
    document.getElementById("quote-form")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section className="relative min-h-[600px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img src={heroImage} alt="Nardy Automation industrial parts warehouse in Florida" className="w-full h-full object-cover" width={1920} height={800} fetchPriority="high" loading="eager" decoding="async" />
        <div className="absolute inset-0 bg-gradient-to-r from-surface-darker/95 via-surface-darker/80 to-surface-darker/60" />
      </div>
      <div className="container relative z-10 py-20 lg:py-28">
        <div className="max-w-2xl">
          <h1 className="font-display text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-4 leading-tight">
            Global Supplier of Transformer Parts & Industrial Components
          </h1>
          <p className="text-brand-light font-display text-lg md:text-xl font-semibold mb-3">
            Bushings, Buchholz Relays, Insulators, Disconnect Switches & Automation Parts
          </p>
          <p className="text-secondary-foreground/80 text-base md:text-lg mb-8 leading-relaxed max-w-xl">
            Nardy Automation supplies the complete range of transformer parts and industrial automation components — from our US warehouse to customers in over 80 countries. Engineering support, hard-to-find sourcing, fast worldwide shipping.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 mb-12">
            <Link to="/transformer-parts">
              <Button size="lg" className="bg-gradient-brand text-primary-foreground font-semibold text-base px-8 py-6 hover:opacity-90 transition-opacity">
                Transformer Solutions
              </Button>
            </Link>
            <Link to="/industrial-automation-parts">
              <Button size="lg" variant="outline" className="border-brand/50 text-brand hover:bg-brand/10 font-semibold text-base px-8 py-6">
                Automation Parts
              </Button>
            </Link>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {trustBadges.map((badge) => (
              <Link key={badge.label} to={badge.to} className="flex items-center gap-2 bg-surface-darker/60 backdrop-blur-sm border border-brand/20 rounded-lg px-3 py-2.5 hover:border-brand/50 hover:bg-brand/10 transition-colors">
                <badge.icon className="w-5 h-5 text-brand flex-shrink-0" />
                <span className="text-secondary-foreground text-sm font-medium">{badge.label}</span>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
